// API endpoint
const API_BASE_URL = '/api';

const getFetchOptions = () => ({
  method: 'GET',
  headers: {
    'accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

const handleResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const text = await response.text();
    throw new Error(`Ожидался JSON, получен: ${text.substring(0, 100)}`);
  }
  return response.json();
};

export const api = {
  async getGroups(organization) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/schedule/${organization}/groups`,
        getFetchOptions()
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await handleResponse(response);
      
      // Если ответ - массив, возвращаем его напрямую
      if (Array.isArray(data)) {
        return data;
      }
      
      // Если ответ в формате {code, message}
      if ((data.code === 0 || data.code === 200) && data.message) {
        // Проверяем все возможные варианты структуры
        if (data.message.groups && Array.isArray(data.message.groups)) {
          return data.message.groups;
        }
        if (Array.isArray(data.message)) {
          return data.message;
        }
        // Проверяем, может быть данные в message напрямую как объект с массивом
        if (data.message && typeof data.message === 'object') {
          const keys = Object.keys(data.message);
          for (const key of keys) {
            if (Array.isArray(data.message[key])) {
              return data.message[key];
            }
          }
        }
      }
      throw new Error(data.error || data.message?.error || 'Ошибка загрузки групп');
    } catch (error) {
      throw error;
    }
  },

  async getTeachers(organization) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/schedule/${organization}/teachers`,
        getFetchOptions()
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await handleResponse(response);
      
      // Если ответ - массив, возвращаем его напрямую
      if (Array.isArray(data)) {
        return data;
      }
      
      // Если ответ в формате {code, message}
      if ((data.code === 0 || data.code === 200) && data.message) {
        // Проверяем все возможные варианты структуры
        if (data.message.teachers && Array.isArray(data.message.teachers)) {
          return data.message.teachers;
        }
        if (Array.isArray(data.message)) {
          return data.message;
        }
        // Проверяем, может быть данные в message напрямую как объект с массивом
        if (data.message && typeof data.message === 'object') {
          const keys = Object.keys(data.message);
          for (const key of keys) {
            if (Array.isArray(data.message[key])) {
              return data.message[key];
            }
          }
        }
      }
      throw new Error(data.error || data.message?.error || 'Ошибка загрузки преподавателей');
    } catch (error) {
      throw error;
    }
  },

  async getGroupSchedule(organization, groupGuid, dateFrom, dateTo) {
    try {
      const formattedDateFrom = formatDateForAPI(dateFrom);
      const formattedDateTo = formatDateForAPI(dateTo);
      const response = await fetch(
        `${API_BASE_URL}/schedule/${organization}/group/${groupGuid}?datebegin=${formattedDateFrom}&dateend=${formattedDateTo}`,
        getFetchOptions()
      );
      
      if (!response.ok) {
        // Если статус 400, проверяем тело ответа на ошибку валидации дат
        if (response.status === 400) {
          try {
            const errorData = await response.json();
            if (errorData.error && errorData.error.includes('некорректная дата')) {
              throw new Error('Некорректный промежуток даты расписания');
            }
          } catch (parseError) {
            // Если не удалось распарсить JSON, используем стандартное сообщение
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await handleResponse(response);
      
      // Если ответ - массив, возвращаем его напрямую
      if (Array.isArray(data)) {
        return data;
      }
      
      // Если ответ в формате {code, message}
      if ((data.code === 0 || data.code === 200) && data.message) {
        if (data.message.schedule && Array.isArray(data.message.schedule)) {
          return data.message.schedule;
        }
        if (Array.isArray(data.message)) {
          return data.message;
        }
        // Проверяем, может быть данные в message напрямую как объект с массивом
        if (data.message && typeof data.message === 'object') {
          const keys = Object.keys(data.message);
          for (const key of keys) {
            if (Array.isArray(data.message[key])) {
              return data.message[key];
            }
          }
        }
      }
      throw new Error(data.error || data.message?.error || 'Ошибка загрузки расписания');
    } catch (error) {
      throw error;
    }
  },

  async getTeacherSchedule(organization, teacherGuid, dateFrom, dateTo) {
    try {
      const formattedDateFrom = formatDateForAPI(dateFrom);
      const formattedDateTo = formatDateForAPI(dateTo);
      const response = await fetch(
        `${API_BASE_URL}/schedule/${organization}/teacher/${teacherGuid}?datebegin=${formattedDateFrom}&dateend=${formattedDateTo}`,
        getFetchOptions()
      );
      
      if (!response.ok) {
        // Если статус 400, проверяем тело ответа на ошибку валидации дат
        if (response.status === 400) {
          try {
            const errorData = await response.json();
            if (errorData.error && errorData.error.includes('некорректная дата')) {
              throw new Error('Некорректный промежуток даты расписания');
            }
          } catch (parseError) {
            // Если не удалось распарсить JSON, используем стандартное сообщение
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await handleResponse(response);
      
      // Если ответ - массив, возвращаем его напрямую
      if (Array.isArray(data)) {
        return data;
      }
      
      // Если ответ в формате {code, message}
      if ((data.code === 0 || data.code === 200) && data.message) {
        if (data.message.schedule && Array.isArray(data.message.schedule)) {
          return data.message.schedule;
        }
        if (Array.isArray(data.message)) {
          return data.message;
        }
        // Проверяем, может быть данные в message напрямую как объект с массивом
        if (data.message && typeof data.message === 'object') {
          const keys = Object.keys(data.message);
          for (const key of keys) {
            if (Array.isArray(data.message[key])) {
              return data.message[key];
            }
          }
        }
      }
      throw new Error(data.error || data.message?.error || 'Ошибка загрузки расписания');
    } catch (error) {
      throw error;
    }
  }
};

// Преобразование даты из YYYY-MM-DD в DD-MM-YYYY
export const formatDateForAPI = (dateStr) => {
  if (!dateStr) return '';
  // Если дата уже в формате DD-MM-YYYY, возвращаем как есть
  if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
    return dateStr;
  }
  // Преобразуем из YYYY-MM-DD в DD-MM-YYYY
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return dateStr;
};

export const formatTime = (timeStr) => {
  if (!timeStr) return '';
  if (timeStr.includes(':')) {
    const parts = timeStr.split(':');
    return `${parts[0]}:${parts[1]}`;
  }
  return timeStr;
};

